import {
  CheckBoxComponent,
  SwitchComponent,
} from '@syncfusion/ej2-react-buttons';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import {
  CheckBoxSelection,
  DropDownListComponent,
  Inject,
  MultiSelectComponent,
} from '@syncfusion/ej2-react-dropdowns';
import { FilterType, GanttComponent } from '@syncfusion/ej2-react-gantt';
import { NumericTextBoxComponent } from '@syncfusion/ej2-react-inputs';
import React, { useEffect } from 'react';
import {
  EditGanttSettings,
  GetGanttSettings,
} from '../../services/CloudScheduler/CloudSchedulerServices';
import Message from '../../utils/Message/Message';

let topTierUnit: any;
let bottomTierUnit: any;
let topTierCount: any;
let bottomTierCount: any;
let timelineUnitSize: any;
let unitField = { text: 'unit', value: 'id' };
let formatField = { text: 'format', value: 'id' };
let yearformat = [
  { id: 'MMM "yy', format: 'Jan "18' },
  { id: 'y', format: '2018' },
  { id: 'MMMM, y', format: 'January, 18' },
];
let monthformat = [
  { id: 'MMM dd, yyyy', format: 'Jan 01, 2018' },
  { id: 'MMMM', format: 'January' },
  { id: 'MMM', format: 'Jan' },
];
let weekformat = [
  { id: 'MMM dd, yyyy', format: 'Jan 01, 2019' },
  { id: 'EEE MMM dd, "yy', format: 'Mon Jan 01, "19' },
  { id: 'EEE MMM dd', format: 'Mon Jan 01' },
];
let dayformat = [
  { id: '', format: 'M' },
  { id: 'EEE', format: 'Mon' },
  { id: 'dd', format: '01' },
];
let hourformat = [
  { id: 'hh', format: '00' },
  { id: 'hh : mm a', format: '00 : 00 AM' },
  { id: 'h : mm a', format: '0 : 00 AM' },
];
let unit = [
  { id: 'Year', unit: 'Year' },
  { id: 'Month', unit: 'Month' },
  { id: 'Week', unit: 'Week' },
  { id: 'Day', unit: 'Day' },
  { id: 'Hour', unit: 'Hour' },
];
let workDays = [
  { id: 'Sunday', day: 'Sunday' },
  { id: 'Monday', day: 'Monday' },
  { id: 'Tuesday', day: 'Tuesday' },
  { id: 'Wednesday', day: 'Wednesday' },
  { id: 'Thursday', day: 'Thursday' },
  { id: 'Friday', day: 'Friday' },
  { id: 'Saturday', day: 'Saturday' },
];
let topTierCheckbox: CheckBoxComponent = new CheckBoxComponent({});
let bottomTierCheckbox: CheckBoxComponent = new CheckBoxComponent({});
let multiselectObj: MultiSelectComponent = new MultiSelectComponent({});
let multiselectForTradeObj: MultiSelectComponent = new MultiSelectComponent({});
let topTierformatDD: DropDownListComponent = new DropDownListComponent({});
let bottomTierformat: DropDownListComponent = new DropDownListComponent({});
let rangeDateTimeObj: DateRangePickerComponent = new DateRangePickerComponent(
  {}
);
let workStartTime: NumericTextBoxComponent = new NumericTextBoxComponent({});
let workEndTime: NumericTextBoxComponent = new NumericTextBoxComponent({});
const defaultValue = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];
const linesData = [
  { id: 'Both', type: 'Both' },
  { id: 'Vertical', type: 'Vertical' },
  { id: 'Horizontal', type: 'Horizontal' },
  { id: 'None', type: 'None' },
];
let isTimeUpdated: boolean = false;
let settingID: number = 0;
let isRenderDone: boolean = false;
interface IProp {
  allowDragDrop: boolean;
  setAllowDragDrop: (cond: boolean) => void;
  allowSeg: boolean;
  setAllowSeg: (cond: boolean) => void;
  gantObj: GanttComponent;
  dayWorkingTime: Array<any>;
  setDayWorkingTime: (cond: Array<any>) => void;
}
const GanttSettings = ({
  allowDragDrop,
  allowSeg,
  gantObj,
  setAllowSeg,
  setDayWorkingTime,
}: IProp) => {
  const topTierCick = (props: any) => {
    if (topTierCheckbox.checked) {
      if (gantObj.timelineSettings.topTier)
        gantObj.timelineSettings.topTier.unit = 'Week';
      topTierCount.enabled = true;
      topTierformatDD.enabled = true;
      topTierUnit.enabled = true;
    } else {
      if (gantObj.timelineSettings.topTier)
        gantObj.timelineSettings.topTier.unit = 'None';
      topTierCount.enabled = false;
      topTierformatDD.enabled = false;
      topTierUnit.enabled = false;
    }
    gantObj.refresh();
  };
  const bottomTierCick = (props: any) => {
    if (bottomTierCheckbox.checked) {
      if (gantObj.timelineSettings.bottomTier)
        gantObj.timelineSettings.bottomTier.unit = 'Day';
      bottomTierCount.enabled = true;
      bottomTierformat.enabled = true;
      bottomTierUnit.enabled = true;
    } else {
      if (gantObj.timelineSettings.bottomTier) {
        gantObj.timelineSettings.bottomTier.unit = 'None';
      }
      bottomTierCount.enabled = false;
      bottomTierformat.enabled = false;
      bottomTierUnit.enabled = false;
    }
    gantObj.refresh();
  };
  const topTierCountchange = (e: any) => {
    let count = e?.value;
    if (gantObj.timelineSettings.topTier) {
      gantObj.timelineSettings.topTier.count = count;
    }
    gantObj.refresh();
  };
  const bottomTierCountchange = (e: any) => {
    let count = e?.value;
    if (gantObj.timelineSettings.bottomTier) {
      gantObj.timelineSettings.bottomTier.count = count;
    }
    gantObj.refresh();
  };
  const topUnitChange = (e: any) => {
    let unit = e?.value;
    if (gantObj.timelineSettings.topTier) {
      gantObj.timelineSettings.topTier.unit = unit;
    }
    if (unit === 'Year') {
      topTierformatDD.dataSource = yearformat;
    } else if (unit === 'Month') {
      topTierformatDD.dataSource = monthformat;
    } else if (unit === 'Week') {
      topTierformatDD.dataSource = weekformat;
    } else if (unit === 'Day') {
      topTierformatDD.dataSource = dayformat;
    } else {
      topTierformatDD.dataSource = hourformat;
    }
    // topTierformatDD.refresh();
    updateUnitWidth(unit, 'top');
    // gantObj.refresh();
  };
  const bottomUnitChange = (e: any) => {
    let unit = e?.value;
    if (gantObj.timelineSettings.bottomTier) {
      gantObj.timelineSettings.bottomTier.unit = unit;
    }
    if (unit === 'Year') {
      bottomTierformat.dataSource = yearformat;
    } else if (unit === 'Month') {
      bottomTierformat.dataSource = monthformat;
    } else if (unit === 'Week') {
      bottomTierformat.dataSource = weekformat;
    } else if (unit === 'Day') {
      bottomTierformat.dataSource = dayformat;
    } else {
      bottomTierformat.dataSource = hourformat;
    }
    bottomTierformat.refresh();
    updateUnitWidth(unit, 'bottom');
    gantObj.refresh();
  };
  const bottomFormatChange = (e: any) => {
    let format = e?.value;
    if (gantObj.timelineSettings.bottomTier) {
      gantObj.timelineSettings.bottomTier.format = format?.toString();
    }
    gantObj.refresh();
  };
  const topFormatChange = (e: any) => {
    let format = e?.value;
    if (gantObj.timelineSettings.topTier) {
      gantObj.timelineSettings.topTier.format = format?.toString();
    }
    gantObj.refresh();
  };
  const unitWidth = (e: any) => {
    let width = e?.value;
    gantObj.timelineSettings.timelineUnitSize = width;
    gantObj.refresh();
  };
  const updateUnitWidth = (unit: any, tier: any) => {
    let topUnit =
      tier === 'top' ? unit : gantObj.timelineSettings.topTier?.unit;
    let bottomUnit =
      tier === 'bottom' ? unit : gantObj.timelineSettings.bottomTier?.unit;
    let units = ['None', 'Hour', 'Day', 'Week', 'Month', 'Year'];
    let bootomCellUnit;
    let unitWidth;
    if (units.indexOf(topUnit) === 0 && units.indexOf(bottomUnit) === 0) {
      bootomCellUnit = 'Day';
    } else if (units.indexOf(topUnit) === 0 && units.indexOf(bottomUnit) > 0) {
      bootomCellUnit = bottomUnit;
    } else if (units.indexOf(topUnit) > 0 && units.indexOf(bottomUnit) === 0) {
      bootomCellUnit = topUnit;
    } else if (units.indexOf(topUnit) <= units.indexOf(bottomUnit)) {
      bootomCellUnit = topUnit;
    } else {
      bootomCellUnit = bottomUnit;
    }
    if (bootomCellUnit === 'Year') {
      unitWidth = 2000;
    } else if (bootomCellUnit === 'Month') {
      unitWidth = 300;
    } else if (bootomCellUnit === 'Week') {
      unitWidth = 150;
    } else if (bootomCellUnit === 'Day') {
      unitWidth = 33;
    } else if (bootomCellUnit === 'Hour') {
      unitWidth = 25;
    }
    timelineUnitSize.value = unitWidth;
    // gantObj.refresh();
  };
  const switchOnChange = (e: any) => {
    localStorage.setItem('cs-drag-drop-enabled', e.target.checked);
    if (e.target.checked) {
      gantObj.editSettings.allowTaskbarEditing = true;
    } else {
      gantObj.editSettings.allowTaskbarEditing = false;
    }
  };
  const switchAllowSegOnChange = (e: any) => {
    localStorage.setItem('cs-allow-seg-enabled', e.target.checked);
    setAllowSeg(e.target.checked);
  };
  const removed = (args: any) => {
    let index = gantObj.workWeek.indexOf(args.itemData.day);
    if (index !== -1) {
      gantObj.workWeek = multiselectObj?.value as any;
    }
  };
  const select = (args: any) => {
    let workingDays: Array<any> = [];
    if(multiselectObj?.value){
      workingDays = multiselectObj?.value;
    }
    workingDays.push(args.itemData.day);
    gantObj.workWeek = workingDays;
  };
  const updateTime = (args: any) => {
    if (!args.isInteracted) {
      return;
    }
    let defaultDate = '08/08/2016',
      startDate = new Date(defaultDate),
      endDate = new Date(defaultDate);
    let decPlace = workStartTime?.value - Math.floor(workStartTime?.value);
    startDate.setHours(workStartTime?.value);
    startDate.setMinutes(decPlace * 60);
    decPlace = workEndTime?.value - Math.floor(workEndTime?.value);
    endDate.setHours(workEndTime?.value);
    endDate.setMinutes(decPlace * 60);
    /*Validate time value and update the time range*/
    if (startDate.getTime() < endDate.getTime() && isTimeUpdated == false) {
      let workingTime = [
        { from: workStartTime?.value, to: workEndTime?.value },
      ];
      gantObj.dayWorkingTime = workingTime;
      isTimeUpdated = false;
      var hours = workEndTime?.value - workStartTime?.value;
      let objGant = {
        component_type: 'gantt',
        settings_name: 'workingTime',
        content: JSON.stringify(workingTime),
        value: hours?.toString(),
        id: settingID,
      };
      saveGanttSettings(objGant);
    } else {
      isTimeUpdated = true;
      workStartTime.value = gantObj.dayWorkingTime[0].from as any;
      workEndTime.value = gantObj.dayWorkingTime[
        gantObj.dayWorkingTime.length - 1
      ].to as any;
    }
    isTimeUpdated = false;
  };
  const changeLine = (args: any) => {
    let lines = args?.value?.toString();
    gantObj.gridLines = lines;
    gantObj.refresh();
  };
  const onChange = (sel: {
    itemData: { text: string; value: string };
  }): void => {
    gantObj.filterSettings.type = sel.itemData?.value as FilterType;
    gantObj.clearFiltering();
  };
  const saveGanttSettings = (obj: any) => {
    EditGanttSettings(obj)
      .then((err) => {
        Message.success('Success..');
        if (settingID === undefined) {
          getGanttSettings('gantt$workingTime');
        }
      })
      .catch((err) => {
        Message.error('Error occured while saving gantt settings');
      });
  };
  const getGanttSettings = (query: string) => {
    GetGanttSettings(query).then((res) => {
      if (res.data[0]) {
        let value = JSON.parse(res.data[0]?.content);
        settingID = 0;
        settingID = res?.data[0]?.id;
        if (Array.isArray(value)) {
          setDayWorkingTime(value);
          workStartTime && (workStartTime.value = Number(value[0].from));
          workEndTime && (workEndTime.value = Number(value[0].to));
        }
      }
    });
  };
  useEffect(() => {
    if(!isRenderDone){
      getGanttSettings('gantt$workingTime');
      isRenderDone = true;
    }
    return () => {
      isRenderDone = false;
    }
  },[]);
  return (
    <>
      <div className='col-lg-12 property-section'>
        <table
          id='property'
          className='property-panel-table table'
          title='Properties'
          style={{
            width: '100%',
            color: 'white',
            backgroundColor: 'black',
          }}
        >
          <tbody>
            <tr>
              <td style={{ width: '30%' }}>
                <div>Unit width</div>
              </td>
              <td style={{ width: '70%' }}>
                <div>
                  <NumericTextBoxComponent
                    ref={(NumericTextBox) =>
                      (timelineUnitSize = NumericTextBox)
                    }
                    format='n'
                    value={50}
                    min={10}
                    change={unitWidth}
                  ></NumericTextBoxComponent>
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <div>
                  <b>Top tier</b>
                </div>
              </td>
              <td style={{ width: '70%' }}>
                <div>
                  <CheckBoxComponent
                    ref={(CheckBox: CheckBoxComponent) =>
                      (topTierCheckbox = CheckBox)
                    }
                    id='topTierCheck'
                    onChange={topTierCick}
                    className='checkbox'
                    checked={true}
                  ></CheckBoxComponent>
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <div>Count</div>
              </td>
              <td style={{ width: '70%' }}>
                <div>
                  <NumericTextBoxComponent
                    ref={(NumericTextBox) => (topTierCount = NumericTextBox)}
                    id='count-2'
                    format='n'
                    min={1}
                    max={50}
                    value={1}
                    className='form-control'
                    change={topTierCountchange}
                  ></NumericTextBoxComponent>
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <div>Unit</div>
              </td>
              <td style={{ width: '70%' }}>
                <div>
                  <DropDownListComponent
                    ref={(DropDownList) => (topTierUnit = DropDownList)}
                    id='unit-top-tier'
                    tabIndex={1}
                    dataSource={unit}
                    fields={unitField}
                    value='Week'
                    change={topUnitChange}
                  ></DropDownListComponent>
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <div>Format</div>
              </td>
              <td style={{ width: '70%' }}>
                <div>
                  <DropDownListComponent
                    ref={(DropDownList: DropDownListComponent) =>
                      (topTierformatDD = DropDownList)
                    }
                    id='topformat'
                    tabIndex={1}
                    dataSource={weekformat}
                    fields={formatField}
                    value='MMM dd, yyyy'
                    change={topFormatChange}
                  ></DropDownListComponent>
                </div>
              </td>
            </tr>

            <tr>
              <td style={{ width: '30%' }}>
                <div>
                  <b>Bottom tier</b>
                </div>
              </td>
              <td style={{ width: '70%' }}>
                <div>
                  <CheckBoxComponent
                    ref={(CheckBox: CheckBoxComponent) =>
                      (bottomTierCheckbox = CheckBox)
                    }
                    id='bottomTierCheck'
                    onChange={bottomTierCick}
                    className='checkbox'
                    checked={true}
                  ></CheckBoxComponent>
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <div>Count</div>
              </td>
              <td style={{ width: '70%' }}>
                <div>
                  <NumericTextBoxComponent
                    ref={(NumericTextBox) => (bottomTierCount = NumericTextBox)}
                    id='count'
                    format='n'
                    min={1}
                    max={50}
                    value={1}
                    className='form-control'
                    change={bottomTierCountchange}
                  ></NumericTextBoxComponent>
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <div>Unit</div>
              </td>
              <td style={{ width: '70%' }}>
                <div>
                  <DropDownListComponent
                    ref={(DropDownList) => (bottomTierUnit = DropDownList)}
                    id='unit-1'
                    tabIndex={1}
                    dataSource={unit}
                    fields={unitField}
                    value='Day'
                    change={bottomUnitChange}
                  ></DropDownListComponent>
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <div>Format</div>
              </td>
              <td style={{ width: '70%' }}>
                <div>
                  <DropDownListComponent
                    ref={(DropDownList: DropDownListComponent) =>
                      (bottomTierformat = DropDownList)
                    }
                    id='btFormat'
                    tabIndex={1}
                    dataSource={dayformat}
                    fields={formatField}
                    value=''
                    change={bottomFormatChange}
                  ></DropDownListComponent>
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <div>Working Days</div>
              </td>
              <td style={{ width: '70%' }}>
                <div style={{ paddingTop: '0px' }}>
                  <MultiSelectComponent
                    ref={(multiselect: MultiSelectComponent) =>
                      (multiselectObj = multiselect)
                    }
                    id='WorkWeek'
                    mode='CheckBox'
                    value={defaultValue}
                    dataSource={workDays}
                    showDropDownIcon={true}
                    popupHeight='350px'
                    fields={{ text: 'day', value: 'id' }}
                    select={select}
                    removed={removed}
                  >
                    <Inject services={[CheckBoxSelection]}></Inject>
                  </MultiSelectComponent>
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <div>Grid Lines</div>
              </td>

              <td style={{ width: '70%' }}>
                <div>
                  <DropDownListComponent
                    // ref={(dropdown:DropDownListComponent) => (dropdownObj = dropdown}
                    id='gridLines'
                    dataSource={linesData}
                    fields={{ text: 'type', value: 'id' }}
                    value='Both'
                    change={changeLine}
                  ></DropDownListComponent>
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <div>Work Start Time</div>
              </td>
              <td style={{ width: '70%' }}>
                <div style={{ paddingTop: '0px' }}>
                  <NumericTextBoxComponent
                    ref={(NumericTextBox: NumericTextBoxComponent) =>
                      (workStartTime = NumericTextBox)
                    }
                    value={0}
                    min={0}
                    max={11}
                    showSpinButton={true}
                    width='150px'
                    step={0.5}
                    change={updateTime}
                  ></NumericTextBoxComponent>
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <div>Work End Time</div>
              </td>
              <td style={{ width: '70%' }}>
                <div style={{ paddingTop: '0px' }}>
                  <NumericTextBoxComponent
                    ref={(NumericTextBox: NumericTextBoxComponent) =>
                      (workEndTime = NumericTextBox)
                    }
                    value={24}
                    min={12}
                    max={24}
                    showSpinButton={true}
                    width='150px'
                    step={0.5}
                    change={updateTime}
                  ></NumericTextBoxComponent>
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <div>Filter Type</div>
              </td>
              <td style={{ width: '70%' }}>
                <div style={{ paddingTop: '0px' }}>
                  <DropDownListComponent
                    id='ddlelement'
                    dataSource={[
                      { text: 'Menu', value: 'Menu' },
                      { text: 'Checkbox', value: 'CheckBox' },
                      { text: 'Excel', value: 'Excel' },
                    ]}
                    fields={{ text: 'text', value: 'value' }}
                    change={onChange}
                    index={0}
                    popupHeight='150px'
                    width='150px'
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <div>Splitter View</div>
              </td>
              <td style={{ width: '70%' }}>
                <div style={{ paddingTop: '0px' }}>
                  <DropDownListComponent
                    dataSource={[
                      {
                        item: 'Grid Only',
                        id: '1',
                      },
                      {
                        item: 'Chart Only',
                        id: '2',
                      },
                      {
                        item: 'Grid and Chart',
                        id: '3',
                      },
                    ]}
                    fields={{ value: 'id', text: 'item' }}
                    onChange={(args: any) => {
                      if (args?.value === '1') {
                        gantObj.setSplitterPosition('100%', 'position');
                      } else if (args?.value === '2') {
                        gantObj.setSplitterPosition('0%', 'position');
                      } else if (args?.value === '3') {
                        gantObj.setSplitterPosition('50%', 'position');
                      }
                    }}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <div>Allow Drag&Drop</div>
              </td>
              <td style={{ width: '70%' }}>
                <div style={{ paddingTop: '0px' }}>
                  <SwitchComponent
                    onChange={switchOnChange}
                    checked={allowDragDrop}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%' }}>
                <div>Allow Segmentation</div>
              </td>
              <td style={{ width: '70%' }}>
                <div style={{ paddingTop: '0px' }}>
                  <SwitchComponent
                    onChange={switchAllowSegOnChange}
                    checked={allowSeg}
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};
export default React.memo(GanttSettings);
